import { register } from "@rill/loader";

register(
	{
		name: "workoutFolders",
		meta: ["no-bust", "workout-folder"],
		ttl: "2 hours",
	},
	async ({ api, locals }) => {
		try {
			const res = await api("workout-folders", {
				// same id the savedWorkouts loader uses, so folders and workouts share a scope
				query: { coachId: locals.activeUserToRequest._id },
			});
			if (!res.ok) return [];
			const data = await res.json();
			return data?.folders ?? [];
		} catch {
			return [];
		}
	},
);
